export default __webpack_public_path__ + "static/char-s-14-jp-3ec59d237eac5999925885193462687b.webp";